import { useCallback, useMemo } from 'react'

function useSentry() {
  // Read window.Sentry at call time rather than tracking it in state: a state-backed
  // availability flag flips after mount, which changes this callback's identity and
  // re-runs every effect that depends on it (MARKETPLACE-JS-8KND).
  const captureException = useCallback((error, options = {}) => {
    if (window.Sentry && typeof window.Sentry.captureException === 'function') {
      return window.Sentry.captureException(error, options)
    }

    return null
  }, [])

  return useMemo(() => ({ captureException }), [captureException])
}

export default useSentry
